<template>
  <div class="vip-upsell" v-if="vipProduct">
    <div class="left">
      <div style="height: 28px;width: 100%;position: relative;">
        <div style="position: absolute;left:-16px;top:-14px;display: flex;background: linear-gradient( 270deg, #FFE8C3 0%, #FFECCC 100%);padding: 5px 10px;border-radius: 0 0 20px 0;overflow: hidden;">
           <img class="plus-icon" style="margin-right: 4px;" :src="isVipIcon" alt="" />
           <span class="vip_text">{{ t('buy.storage.vip_upsell.title') }}</span>
        </div>
      </div>
      <div class="desc">
        <span>{{ t('buy.storage.vip_upsell.prefix') }}</span>
        <span class="save">{{ t('buy.storage.vip_upsell.save', { amount: saveAmount }) }}</span>
      </div>
      <div class="sub">{{ t('buy.storage.vip_upsell.sub') }}</div>
    </div>
    <div class="right">
      <div class="price">
        <span class="text">{{ t('buy.storage.vip_upsell.price_label') }}</span>
        <span class="amount">¥ {{ vipPrice }}</span>
        <el-checkbox v-model="checked" />
      </div>
    </div>
  </div>
</template>

<script setup>
import isVipIcon from '@/assets/usercenter/isvip.png'
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

const store = useStore()
const { t } = useI18n()

const checked = computed({
  get() {
    return store.state.buystorage.upsellVipChecked
  },
  set(v) {
    store.commit('buystorage/setUpsellVipChecked', v)
  },
})

const vipProduct = computed(() => {
  const list = Array.isArray(store.state.buystorage.allUserVip) ? store.state.buystorage.allUserVip : []
  return (
    list.find(it => Number(it?.productSort) === 6) ||
    list.find(it => Number(it?.productSort) === 7) ||
    list.find(it => Number(it?.productSort) === 8) ||
    null
  )
})

const vipPrice = computed(() => {
  const n = Number(store.state.buystorage.vipUpsellPrice ?? 0)
  return Number.isFinite(n) ? n.toFixed(2) : '0.00'
})

onMounted(() => {
  if ((store.state.buystorage.vipUpsellPrice === null || store.state.buystorage.vipUpsellPrice === undefined) && store.dispatch) {
    store.dispatch('buystorage/getVipUpsellPrice')
  }
})

const saveAmount = computed(() => {
  const p = store.state.buystorage.selectTargetProduct || {}
  const num = Number(store.state.buystorage.num || 1)
  const productPrice = Number(p.productPrice ?? 0)
  const productCheapPrice = Number(p.productCheapPrice ?? 0)
  const diff = (productPrice - productCheapPrice) * num
  return diff > 0 ? diff.toFixed(2) : '0.00'
})
</script>

<style scoped lang="less">
.vip-upsell {
  overflow: visible;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border-radius: 6px;
  background: #fff3f3;
  border: 1px solid #ffd5d5;
}

.left {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.desc {
  color: rgba(0, 0, 0, 0.65);
  font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 14px;
}

.save {
  color: #d93737;
  margin-left: 8px;
    font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 14px;
}

.sub {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}

.right {
  display: flex;
  align-items: center;
}

.price {
  display: flex;
  align-items: baseline;
  gap: 6px;
  color: #d93737;
}

.text {
  font-size: 12px;
}

.amount {
  font-size: 16px;
  font-weight: 500;
}
.plus-icon {
  width: 53px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
}
.vip_text{
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 15px;
  color: #D93737;
}
</style>
